export const MonitoringCard: React.FC<React.PropsWithChildren> = ({ children }) => {
	return <>{children}</>;
};
